/**
 * @param text text to truncate
 * @param charLimit number of shown characters
 */
export const ellipsis = (text: string, charLimit: number) => {
    return text.length > charLimit ? text.slice(0, charLimit) + '...' : text;
};
